export default "/ticket-waiver-example.34feef50-ccc8b0.png";